import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=1ed5267a&scoped=true"
var script = {}
import style0 from "./LinkedIn.vue?vue&type=style&index=0&id=1ed5267a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5267a",
  null
  
)

export default component.exports